import apis from "../../core/apis.js";

class UserpromotionResource {
  constructor($resource, Upload) {
    "ngInject";
    this.Upload = Upload;
    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.userpromotion).get(options);
  }

  get(id) {
    return this.$resource(apis.userpromotion + id).get();
  }

  post(item) {
    return this.$resource(apis.userpromotion).save(item);
  }

  update(id, item) {
    return this.$resource(apis.userpromotion + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
  delete(id) {
    return this.$resource(apis.userpromotion + id).delete();
  }
  documentUpload(id, data) {
    const url = `${apis.userpromotion}CSV`;
    data.promotion = id;
    const request = this.Upload.upload({ url, data });
    return { $promise: request };
  }
}

export default UserpromotionResource;



// WEBPACK FOOTER //
// ./src/resources/userpromotion/userpromotion.resource.js